import { Outlet } from "react-router-dom";

import { AUTH_ROLES, AuthRole } from "api/common/types/auth.types";
import JumpVid from "features/memberPortal/products/components/JumpVid";
import { useAuth } from "hooks/useAuth";

const { NIAP, VALIDATOR, LAB } = AUTH_ROLES;
const ALLOWED_ROLES: AuthRole[] = [NIAP, VALIDATOR, LAB];

export default function ProductManager() {
  const { permissions } = useAuth();

  const canViewJumpVid = ALLOWED_ROLES.includes(permissions.role_type);

  return (
    <>
      {canViewJumpVid && <JumpVid />}
      <Outlet />
    </>
  );
}
